export const ISHXTAPP = (() => {
    let ua = navigator.userAgent.toLowerCase();
    let isAndroid = ua.indexOf('hxtapp') !== -1 && ua.indexOf('android') !== -1;
    let isIos = ua.indexOf('hxtapp') !== -1 && ua.indexOf('iphone') !== -1;
    return isAndroid || isIos;
})();

export const ISWECHAT = (() => {
    let ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
})();